var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 40,
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.5705 17.143C34.5053 17.097 23.3634 10.4923 23.2917 10.4473C22.3941 9.84999 21.3255 9.85184 20.4303 10.4473C19.5351 11.0445 19 12.1115 19 13.3042V26.6919C19 27.8846 19.5351 28.9515 20.4303 29.5488C20.8867 29.8521 21.3881 30 21.8799 30C22.3532 30 22.8168 29.8632 23.2227 29.5913L34.5705 22.8531C35.4657 22.2558 36 21.1889 36 19.998C36 18.8072 35.4657 17.7402 34.5705 17.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.2365 0.574878C45.4959 -0.191626 44.2961 -0.191626 43.5555 0.574878C42.8148 1.34138 42.8148 2.58312 43.5555 3.34962C47.8455 7.78959 50.208 13.7032 50.208 20C50.208 26.2968 47.8455 32.2104 43.5555 36.6504C42.8148 37.4169 42.8148 38.6586 43.5555 39.4251C43.9258 39.8084 44.4109 40 44.896 40C45.3811 40 45.8662 39.8084 46.2365 39.4251C51.2431 34.2455 54 27.3469 54 20C54 12.6531 51.2431 5.75453 46.2365 0.574878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.3302 6.56037C39.5682 5.81321 38.3336 5.81321 37.5715 6.56037C36.8095 7.30754 36.8095 8.51795 37.5715 9.26511C43.609 15.1845 43.609 24.8155 37.5715 30.7349C36.8095 31.4821 36.8095 32.6925 37.5715 33.4396C37.9526 33.8132 38.4517 34 38.9509 34C39.45 34 39.9492 33.8132 40.3302 33.4396C43.9862 29.8551 46 25.0826 46 20C46 14.9174 43.9862 10.1449 40.3302 6.56037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.4445 3.34962C11.1852 2.58312 11.1852 1.34138 10.4445 0.574878C9.70381 -0.191626 8.50391 -0.191626 7.76324 0.574878C2.75718 5.75453 0 12.655 0 20C0 27.345 2.75718 34.2455 7.76324 39.4251C8.13357 39.8084 8.61872 40 9.10386 40C9.58901 40 10.0742 39.8084 10.4445 39.4251C11.1852 38.6586 11.1852 37.4169 10.4445 36.6504C1.57302 27.4696 1.57302 12.5304 10.4445 3.34962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.4285 6.56037C15.6665 5.81321 14.4321 5.81321 13.6701 6.56037C10.0135 10.1449 8 14.9174 8 20C8 25.0826 10.0135 29.8551 13.6701 33.4396C14.0511 33.8132 14.5502 34 15.0493 34C15.5484 34 16.0475 33.8132 16.4285 33.4396C17.1905 32.6925 17.1905 31.4821 16.4285 30.7349C13.5092 27.8732 11.9014 24.0608 11.9014 20C11.9014 15.9392 13.5092 12.1268 16.4285 9.26511C17.1905 8.51795 17.1905 7.30754 16.4285 6.56037Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcast);
export default __webpack_public_path__ + "static/media/iconcast.06e758127dad40460afe3ec37183f5f5.svg";
export { ForwardRef as ReactComponent };